import React from "react";
import { NavLink } from "react-router-dom";

const FamilyLawValuationTab = () => {
  return (
    <div className="space-y-4 text-gray-800 py-10">
      <h2 className="text-xl font-semibold text-red-600">
        Familiy Law Valuation
      </h2>

      <div className="space-y-2">
        <p>
          Family law property valuation are required when married/defacto
          relationships are separated and they require settlement valuation to
          divide the property assets. Primus Agent Services have over
          ten (10) years experience in providing family law valuation to Family
          Law Courts.
        </p>
      </div>

      <p className="text-blue-600 font-medium">
        Please{" "}
        <NavLink to="/contact-us" className="text-yellow">
          contact us{" "}
        </NavLink>{" "}
        for a guaranteed competitive quote.
      </p>
    </div>
  );
};

export default FamilyLawValuationTab;
